import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "../client";

/**
 * Forces a health-score recompute for a single customer. Invalidates the
 * cached Customer 360 query and the list query on success so the page +
 * dashboard chip reflect the fresh row.
 */
export function useRecomputeHealth(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      client
        .post(`/admin/customers/${customerId}/health-score/recompute`)
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["crm", "customer360", customerId] });
      qc.invalidateQueries({ queryKey: ["crm", "customers"] });
    },
  });
}

/**
 * Bulk-recompute every customer's health score. Returns {success, failed}.
 * Only invalidates the list query — individual 360 pages re-read on next
 * mount. Used from the dashboard header.
 */
export function useRecomputeAllHealth() {
  const qc = useQueryClient();
  return useMutation<{ success: number; failed: number }>({
    mutationFn: () =>
      client
        .post(`/admin/customers/health-score/recompute-all`)
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["crm", "customers"] });
    },
  });
}
